import { store } from '../store';

class MobileCheckService {
    private static serviceInstance: MobileCheckService;

    private hasTouchScreen = false;

    private constructor() {
        this.detectTouchScreen();
    }

    public static get instance() {
        if (!this.serviceInstance) {
            this.serviceInstance = new this();
        }
        return this.serviceInstance;
    }

    public get hideSlidersOnTouchScreens() {
        return store.getters['initialSettingsModule/hideSlidersOnTouchScreens'];
    }

    private detectTouchScreen() {
        if ('maxTouchPoints' in navigator) {
            this.hasTouchScreen = navigator.maxTouchPoints > 0;
        } else if ('msMaxTouchPoints' in navigator) {
            // eslint-disable-next-line dot-notation
            this.hasTouchScreen = navigator['msMaxTouchPoints'] > 0;
        } else {
            const mQ = matchMedia
                ? matchMedia('(pointer:coarse)')
                : null;
            if (mQ && mQ.media === '(pointer:coarse)') {
                this.hasTouchScreen = !!mQ.matches;
            } else if ('orientation' in window) {
                this.hasTouchScreen = true; // deprecated, but good fallback
            } else {
                // eslint-disable-next-line dot-notation
                const UA = navigator['userAgent'];
                this.hasTouchScreen = /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
            }
        }
    }

    public get isOnMobile(): boolean {
        return this.hasTouchScreen;
    }

    public get hideSliders(): boolean {
        return this.hasTouchScreen && this.hideSlidersOnTouchScreens;
    }
}

export default MobileCheckService.instance;
